import { BaseFilterMany, BaseFilterOne, BaseQueryMany } from '@cnx-saas/common';
import { CnxIdType } from '@cnx-saas/utils-cnx-id';
import { Article, Articles } from './Article';

export class FilterArticle
  extends BaseFilterOne(CnxIdType.Article)
  implements ArticleFilters
{
  externalReference?: string;
  name?: string;
  logisticalUnit?: string;
  articlesPerPackage?: number;
  maxStackSize?: number;
}
export class FilterArticles extends BaseFilterMany(CnxIdType.Article) {}

export class FilterPackaging extends BaseFilterOne(CnxIdType.Packaging) {}

export class ArticleFilters {
  externalReference?: string;
  name?: string;
  logisticalUnit?: string;
  articlesPerPackage?: number;
  maxStackSize?: number;
}

export class PackagingFilters {
  ids?: string[];
}
export class QueryArticles extends BaseQueryMany<ArticleFilters>() {}

export class QueryPackaging extends BaseQueryMany<PackagingFilters>() {}

export interface ArticleQueryVariables {
  filter: FilterArticle;
}
export interface ArticleQueryResult {
  article: Article;
}

export interface ArticlesQueryVariables {
  query: QueryArticles;
}
export interface ArticlesQueryResult {
  articles: Articles;
}

export interface ArticlesByExternalReferencesQueryVariables {
  externalReferences: string[];
}
